import { render, staticRenderFns } from "./IzrBrlList.vue?vue&type=template&id=522e9460"
import script from "./IzrBrlList.vue?vue&type=script&lang=js"
export * from "./IzrBrlList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports